/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * First event emitted by `GET /v2/search/{id}/stream`. Tells the
 * client how many provider batches to expect so it can render a
 * deterministic progress indicator.
 * 
 * @export
 * @interface SearchStreamBatchStart
 */
export interface SearchStreamBatchStart {
    /**
     * 
     * @type {string}
     * @memberof SearchStreamBatchStart
     */
    type: SearchStreamBatchStartTypeEnum;
    /**
     * Total number of provider batches in this search.
     * @type {number}
     * @memberof SearchStreamBatchStart
     */
    totalBatches: number;
}


/**
 * @export
 */
export const SearchStreamBatchStartTypeEnum = {
    BatchStart: 'batch_start'
} as const;
export type SearchStreamBatchStartTypeEnum = typeof SearchStreamBatchStartTypeEnum[keyof typeof SearchStreamBatchStartTypeEnum];


/**
 * Check if a given object implements the SearchStreamBatchStart interface.
 */
export function instanceOfSearchStreamBatchStart(value: object): value is SearchStreamBatchStart {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('totalBatches' in value) || value['totalBatches'] === undefined) return false;
    return true;
}

export function SearchStreamBatchStartFromJSON(json: any): SearchStreamBatchStart {
    return SearchStreamBatchStartFromJSONTyped(json, false);
}

export function SearchStreamBatchStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamBatchStart {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'totalBatches': json['total_batches'],
    };
}

export function SearchStreamBatchStartToJSON(json: any): SearchStreamBatchStart {
    return SearchStreamBatchStartToJSONTyped(json, false);
}

export function SearchStreamBatchStartToJSONTyped(value?: SearchStreamBatchStart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'total_batches': value['totalBatches'],
    };
}

